import React from 'react';
import Menu from './components/Menu';

import './css/App.css';
import WinterDutyCalendar from './components/winterDuties/WinterDutyCalendar.js';

const WinterDutyPlan = () => {
  return (
      <div className="App">
          <Menu />
          <WinterDutyCalendar />
      </div>
  );
};

export default WinterDutyPlan;